<template>
  <div class="wrap">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 content">
          <vm v-if="this.render">{{this.markedDatenschutz}}</vm>
          <button
            id="OptOutButton"
            class="btn btn-primary"
            :disabled="this.GADisabled"
            @click="GAOptOut"
          >Google Analytics Opt-Out</button>
          <p>
            <i class="fas fa-info-circle"></i>
            {{this.message}}
          </p>
          <p>This page is powered by <a style="color: white !important" target="_blank" rel="noopener noreferrer" href="https://contentful.com">contenful</a>.</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import client from "../../utils/api.js";
import VueMarkdown from "vue-markdown";
import marked from "marked";
export default {
  name: "Datenschutz",
  data() {
    return {
      datenschutz: "",
      GADisabled: true,
      message: "",
      render: false
    };
  },
  components: {
    vm: VueMarkdown
  },
  computed: {
    markedDatenschutz() {
      this.datenschutz = this.$sanitize(this.datenschutz);
      return marked(this.datenschutz, {});
    }
  },
  methods: {
    GAOptOut() {
      window["ga-disable-" + process.env.VUE_APP_GOOGLE_ANALYTICS] = true;
      this.GADisabled = true;
      this.message = "Goolge Analytics deaktiviert ";
      document.cookie =
        "eSport_Soccercup_A= ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
      document.cookie = "_ga= ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
      document.cookie = "_gid= ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
      document.cookie =
        "_gat_gtag_" +
        process.env.VUE_APP_GOOGLE_ANALYTICS_COOKIE_ID +
        "= ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
      //set essential cookie
      document.cookie =
        "eSport_Soccercup_E" +
        "=true; expires=Thu, 31 Dec 2020 23:59:59 UTC; path=/";
    },
    addLinkAttributes() {
      var links = document.links;
      for (var i = 0, linksLength = links.length; i < linksLength; i++) {
        if (links[i].hostname != window.location.hostname) {
          links[i].target = "_blank";
          links[i].setAttribute("rel", "noopener noreferrer");
          links[i].className += " externalLink";
        } else {
          // links[i].className += " localLink";
        }
      }
    }
  },
  mounted() {
    if (document.cookie.indexOf("eSport_Soccercup_A=true") > -1) {
      //Google Analytics aktiv
      this.GADisabled = false;
      this.message = "Google Analytics ist aktiv";
    } else if (document.cookie.indexOf("eSport_Soccercup_E=true") > -1) {
      this.GADisabled = true;
      this.message = "Google Analytics ist nicht aktiviert";
    } else {
      this.GADisabled = true;
      this.message = "Google Analytics ist nicht aktiviert";
    }
  },
  updated() {
    this.addLinkAttributes();
  },
  created() {
    client
      .getEntries({ content_type: "datenschutz", order: "-sys.createdAt" })
      .then(response => {
        this.datenschutz = response.items[0].fields.erklaerung;

        this.render = true;
      });
  }
};
</script>
<style scoped>
li > p {
  color: white !important;
}
#mainNav {
  display: none !important;
}
.wrap {
  background-color: black !important;
  font-family: "Roboto Condensed", sans-serif;
  padding-top: 20vh;
}

.color-w {
  color: white !important;
}
.container {
  min-height: 100vh;
  color: white !important;
}
.container > h4,
h2,
p {
  color: white !important;
}
.content {
  width: 80%;
  padding-top: 40px;
}

h4 {
  color: white;
  margin-top: 30px;
}

#OptOutButton {
  background: #eb6626;
  border: 1px solid #eb6626;
  margin: 15px 0;
  border-radius: 0;
  font-size: 1em;
}

#OptOutButton:disabled {
  background: transparent;
  border: 1px solid grey;
  margin: 15px 0;
  border-radius: 0;
  color: grey;
  cursor: default;
}

a {
  color: #eb6626 !important;
}

/*XR*/
@media screen and (width: 828px) and (height: 1792px) {
  h2 {
    font-size: 4.5em !important;
  }
  h4 {
    font-size: 2.5em !important;
  }
  p,
  li {
    font-size: 1.9em !important;
  }

  #OptOutButton {
    margin: 30px 0;
    padding: 10px 20px;

    font-size: 1.9em;
  }
}
</style>
